export function userVariables() {
	var variables = {
		code: '',
		username: '',
		prefix_name: '',
		email: '',
		first_name: '',
		last_name: '',
		phone: '',
		authentication_type: '',
		gender: '',
		status: '',
		positions: [],
		user_properties: [],
		profile_image: '',
		signature: ''
	}
	return variables
}

export function positionVariables() {
	var variables = {
		code: '',
		name: '',
		reference_id: '',
		level_id: '',
		role_ids: []
	}
	return variables
}

export function groupVariables() {
	var variables = {
		code: '',
		name: '',
		active_directories: []
	}
	return variables
}


// WEBPACK FOOTER //
// ./src/components/Variable.js